import React from 'react'

import BlockTypes from '@slite/editor/lib/types/BlockTypes'
import IntegrationSuggestion from './components'

export const schema = {
  blocks: {
    [BlockTypes.INTEGRATION_SUGGESTION]: {
      isVoid: true,
    },
  },
}

export default ({ utils: { NormalizationHelper, renderBlocks } }) => ({
  onEnableApp = () => {},
  onConnectApp = () => {},
  onClose = () => {},
  onSuppress = () => {},
  decorator = x => x,
} = {}) => {
  const Component = decorator(IntegrationSuggestion)
  return [
    NormalizationHelper.normalizeNode(BlockTypes.INTEGRATION_SUGGESTION, [
      NormalizationHelper.shouldBeAtRoot,
    ]),

    {
      schema,
      ...renderBlocks({
        [BlockTypes.INTEGRATION_SUGGESTION]: ({
          editor,
          node,
          attributes,
          isSelected,
        }) => {
          const props = [
            'name',
            'description',
            'iconURL',
            'clientId',
            'for',
          ].reduce(function getInData(props, key) {
            return {
              ...props,
              [key]: node.data.get(key),
            }
          }, {})

          function makeRemoveBlockThen(callback) {
            return function removeBlockThenCallback(...args) {
              editor.removeNodeByKey(node.key)
              callback(...args)
            }
          }

          return (
            <div {...attributes}>
              <Component
                {...props}
                focused={isSelected}
                onEnableApp={makeRemoveBlockThen(onEnableApp)}
                onConnectApp={makeRemoveBlockThen(onConnectApp)}
                onClose={makeRemoveBlockThen(onClose)}
                onSuppress={makeRemoveBlockThen(onSuppress)}
              />
            </div>
          )
        },
      }),
    },
  ]
}
